import { useOperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { filterOpInfoTypesTrain } from "features/CenterContent/shared/operationalInformation/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import { Badge, tokens } from "shared/components/Spor";
import colors from "shared/theme/colors";

type ReasonTypeDisplayProps = {
  reasonType: string;
};

export const ReasonTypeDisplay: FC<ReasonTypeDisplayProps> = ({
  reasonType,
}) => {
  const { t } = useTranslation();
  const { data, isError, isPending } = useOperationalInformationTypes(t);
  if (isError) return <FailureMessage />;
  if (isPending) return <SkeletonLoader skeletonType="trainSeries" />;
  const { reasons } = filterOpInfoTypesTrain(data);
  const label = reasons.find((it) => it.type === reasonType)?.label;
  if (!label) return null;
  return (
    <Badge
      data-color="neutral"
      // Figma "surface/neutral/active" (#023530) has no matching Spor token
      background="#023530"
      borderWidth={tokens.default.size.stroke.sm}
      borderColor={colors.teal700}
      fontWeight="normal"
      textStyle="xs"
    >
      {label}
    </Badge>
  );
};
